const styles = (theme) => ({
  scrollableList: {
    paddingLeft: '0 !important',
    paddingRight: '10 !important',
    maxHeight: 350,
    overflowY: 'auto',
    overflowX: 'auto',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    width: '100%',
    boxSizing: 'border-box',

    /* Chrome, Edge, Safari */
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#b0b0b0',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#888',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },

    /* Firefox */
    scrollbarWidth: 'thin',
    scrollbarColor: '#b0b0b0 transparent',
  },

  listItem: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
    marginBottom: '12px',
    padding: '16px',
    transition: 'transform 0.2s ease',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: '70px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      transform: 'scale(1.01)',
      boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
    }
  },

  apiTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#222'
  },

  apiDescription: {
    fontSize: '14px',
    color: '#555',
    lineHeight: 1.4,
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal'
  },

  header: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: '#222'
  },

  p: {
    fontSize: '14px',
    color: '#555',
    lineHeight: 1.4
  },

  colorSwitchBase: {
    '&$colorChecked': {
      color: '#1976d2',
    },
    '&$colorChecked + $colorBar': {
      backgroundColor: '#1976d2',
    }
  },
  colorChecked: {},
  colorBar: {}
});

export default styles;
